<template>
  <transition appear>
    <div data-component="Room" id="roomWrapperStage" class="room stage" v-if="roomClientReady">

      <Peers
        :roomType="roomType"
        v-if="roomClientReady"
        :isPlaying="isPlaying"
        :room-client="roomClient"
      />

       <MeetControlsComponent :roomType="roomType" :room-client="roomClient" />

      <el-dialog
        :title="$t('meetControls.settings')"
        :visible.sync="$store.state.settingsModal"
        class="settings-dialog-wrapper default"
        >

        <CameraSettings
          @closeSettingsModal="closeCameraSettings"
          @userClicked="closeCameraSettings"
          @videoDeviceChanged="videoDeviceChanged"
          @inputDeviceChanged="inputDeviceChanged"
          @outputDeviceChanged="outputDeviceChanged"
          :roomType="roomType"
        />

      </el-dialog>

    </div>
  </transition>
</template>
<script>
import UrlParse from "url-parse";
import Notifications from "../media/Notifications";
import NetworkThrottle from "../media/NetworkThrottle";
import Stats from "../media/Stats";
import ChatInput from "../media/ChatInput";
import Me from "../media/Me";
import Peers from "../media/Peers";
import RoomClient from "../../../utils/RoomClient";
import * as cookiesManager from "../../../utils/cookiesManager";
import deviceInfo from "../../../utils/deviceInfo";
import $ from "jquery";
import randomString from "../../../utils/randomString";
//import randomName from "../../../utils/randomName";
import CameraSettings from "../event/CameraSettings";
import axios from "axios";

import MeetControlsComponent from "..//media/MeetControlsComponent"

export default {
  components: {
    Notifications,
    NetworkThrottle,
    Stats,
    ChatInput,
    Me,
    Peers,
    CameraSettings,
    MeetControlsComponent
  },
  props: {
    roomId: false,
    roomType: null
  },
  data() {
    return {
      firstLogin:false,
      settingsModal: false,
      roomClient: null,
      roomClientReady: false,
      NETWORK_THROTTLE_SECRET: window.NETWORK_THROTTLE_SECRET,
      isPlaying: false,
      inputDeviceId: null,
      videoDeviceId: null
    };
  },
  computed: {
    screenPeer() {
      var consumer = this.$store.state.consumers.find(
        x =>
          x.appData != null &&
          x.appData.share == true &&
          x.appData.source == "screen"
      );

      var meProducer = this.$store.state.producers.find(x => x.type == "share");
      if (meProducer != null) {
        this.myScreenShare = true;
        return this.$store.state.me;
      }

      this.myScreenShare = false;

      if (consumer == null) return null;
      var peer = this.$store.state.peers.find(
        x => x.id == consumer.appData.peerId
      );

      return peer;
    },
    faceDetection() {
      return this.$store.state.faceDetection;
    },
    producers() {
      return this.$store.state.producers;
    },
    audioProducer() {
      return this.producers.find(producer => producer.track.kind === "audio");
    },
    videoProducer() {
      return this.producers.find(
        producer => producer.track.kind === "video" && producer.type !== "share"
      );
    },
    shareProducer() {
      return this.producers.find(producer => producer.type === "share");
    },

    getCurrentSession() {
      return this.$store.getters.getCurrentSession;
    },

    me() {
      return this.$store.state.me;
    },
    amActiveSpeaker() {
      return this.$store.state.me.id === this.$store.state.room.activeSpeakerId;
    },
    room() {
      return this.$store.state.room;
    },
    getParticipantID() {
      return this.$store.state.participant.item.id;
    },
    getPublisher() {
      if (this.roomType == "networking") {
        return {};
      }

      if (this.getCurrentSession == null) {
        return null;
      }

      var publisher = this.getCurrentSession.publishers.find( x => x.participantID == this.getParticipantID && x.isActive == true );
      return publisher;
    },

    changeWebcamState() {
      if (
        Boolean(this.videoProducer) &&
        this.videoProducer.type !== "share" &&
        this.me.canChangeWebcam
      ) {
        return "on";
      } else {
        return "unsupported";
      }
    },

    shareState() {
      if (this.screenPeer != null) {
        return "on";
      }

      if (Boolean(this.videoProducer) && this.videoProducer.type === "share") {
        return "on";
      } else {
        return "off";
      }
    },
    webcamState() {
      let webcamState;

      if (!this.me.canSendWebcam) {
        webcamState = "unsupported";
      } else if (this.videoProducer && this.videoProducer.type !== "share") {
        webcamState = "on";
      } else {
        webcamState = "off";
      }

      return webcamState;
    },
    micState() {
      let micState;

      if (!this.me.canSendMic) {
        micState = "unsupported";
      } else if (!this.audioProducer) {
        micState = "unsupported";
      } else if (!this.audioProducer.paused) {
        micState = "on";
      } else {
        micState = "off";
      }

      return micState;
    }
  },
  mounted() {
    window.localStream = new MediaStream();
    const urlParser = new UrlParse(window.location.href, true);

      const peerId = this.getParticipantID + (Math.floor(Date.now() / 1000).toString());
      let roomId = this.roomId;

      let displayName = this.$store.state.user.fullName;
      let image = this.$store.state.user.image;
      let title = this.$store.state.user.contactInfo != null ? this.$store.state.user.contactInfo.title : '';

      const handler = urlParser.query.handler;
      const useSimulcast = urlParser.query.simulcast !== "false";
      const useSharingSimulcast = urlParser.query.sharingSimulcast !== "false";
      const forceTcp = urlParser.query.forceTcp === "true";
      const produce = true;
      const consume = urlParser.query.consume !== "false";
      const forceH264 = urlParser.query.forceH264 === "true";
      const forceVP9 = urlParser.query.forceVP9 === "true";
      const svc = urlParser.query.svc;
      const datachannel = urlParser.query.datachannel !== "false";
      const info = urlParser.query.info === "true";
      const faceDetection = urlParser.query.faceDetection === "true";
      const externalVideo = urlParser.query.externalVideo === "true";
      const throttleSecret = urlParser.query.throttleSecret;

      if (info) {
        // eslint-disable-next-line require-atomic-updates
        window.SHOW_INFO = true;
      }

      if (throttleSecret) {
        // eslint-disable-next-line require-atomic-updates
        window.NETWORK_THROTTLE_SECRET = throttleSecret;
      }

      if (!roomId) {
        roomId = randomString({ length: 8 }).toLowerCase();

        urlParser.query.roomId = roomId;
        window.history.pushState("", "", urlParser.toString());
      }

      // Get the effective/shareable Room URL.
      const roomUrlParser = new UrlParse(window.location.href, true);
      delete roomUrlParser.hash;
      const roomUrl = roomUrlParser.toString();

      let displayNameSet;

      //If displayName was provided via URL or Cookie, we are done.
      if (displayName) {
        displayNameSet = true;
      }
      //Otherwise pick a random name and mark as "not set".
      else {
        displayNameSet = false;
        displayName = ""
      }

      // Get current device info.
      const device = deviceInfo();

      this.$store.commit("RoomsetRoomUrl", { roomUrl });
      this.$store.commit("RoomsetFaceDetection", { flag: faceDetection });
      this.$store.commit("MesetMe", {
        peerId,
        title,
        displayName,
        image,
        displayNameSet,
        device
      });

      this.roomClient = new RoomClient({
        roomId,
        peerId,
        displayName,
        title,
        image: this.$store.state.user.image,
        device,
        handlerName: handler,
        useSimulcast,
        useSharingSimulcast,
        forceTcp,
        produce,
        consume,
        forceH264,
        forceVP9,
        svc,
        datachannel,
        externalVideo,
        store: this.$store,
        roomType: this.roomType
      });
      this.roomClient.join();

      this.roomClientReady = true;
      this.$root.$on("closeSettingsModal", settings => {
        this.$store.state.settingsModal = true;
      });
  },

  beforeDestroy() {
    localStream.getTracks().forEach(track => track.stop());
    this.$root.$off("closeSettingsModal");
    this.$root.$off("openCameraSettings");
    this.$root.$off("liveStreamChanged");

    this.stopAllVideos();

    this.$store.state.producers = [];
    this.$store.state.consumers = [];
    this.$store.state.peers = [];

    this.roomClient.disableMic();
    this.roomClient.disableWebcam();
    this.roomClient.disableShare();
    this.roomClient.close();
  },
  methods: {
    closeCameraSettings(){
      this.firstLogin = true;
      this.settingsModal = false;
    },
    goBack() {
      this.$store.state.settingsModal = false;
    },
    toggleMicState() {
      this.micState === "on"
        ? this.roomClient.muteMic()
        : this.roomClient.unmuteMic();
    },
    changeWebcam() {
      this.$root.$emit("openCameraSettings");
      //this.roomClient.changeWebcam()
    },
    toggleShare() {
      if (this.shareState === "on") {
        this.roomClient.disableShare();
      } else {
        this.roomClient.enableShare();
      }
    },
    toggleWebcam() {
      console.log("webcamState", this.webcamState);
      if (this.webcamState === "on") {
        cookiesManager.setDevices({ webcamEnabled: false });
        this.roomClient.disableWebcam();
      } else {
        cookiesManager.setDevices({ webcamEnabled: true });
        this.roomClient.enableWebcam();
      }
    },
    videoDeviceChanged(deviceId) {
      console.log("videoDeviceChanged", deviceId);
      this.roomClient.changeWebcam(deviceId);
    },
    outputDeviceChanged(deviceId) {
      console.log("outputDeviceChanged", deviceId);
      for (var i = 0; i < this.$store.state.peers.length; i++) {
          try {
            var id2 = "#audio-" + this.$store.state.peers[i].id;
            console.log(id2);
            $(id2)[0].setSinkId(deviceId);
          } catch (e) {
            console.warn("output device cant changed");
          }
        }
    },
    inputDeviceChanged(deviceId) {
      console.log("inputDeviceChanged", deviceId);
      this.roomClient.changeMic(deviceId);
    },
    muteRemoteAudio() {},
    playAllVideos() {
      this.isPlaying = true;

      for (var i = 0; i < this.$store.state.peers.length; i++) {
        try {
          var id = "#video-" + this.$store.state.peers[i].id;
          var id2 = "#audio-" + this.$store.state.peers[i].id;

          $(id)[0].play();

          var a = localStorage.getItem(
            "mute-audio-" + this.$store.state.peers[i].id
          );
          if (
            localStorage.getItem(
              "mute-audio-" + this.$store.state.peers[i].id
            ) != null
          ) {
            $(id2)[0].pause();
          } else {
            $(id2)[0].play();
          }
        } catch (e) {}
      }
    },
    stopAllVideos() {
      try {
        for (var i = 0; i < this.$store.state.peers.length; i++) {
          var id = "#video-" + this.$store.state.peers[i].id;
          var id2 = "#audio-" + this.$store.state.peers[i].id;

          var a = $(id)[0];
          if (a != null && a != undefined) {
            const stream = a.srcObject;
            stream.getTracks().forEach(function(track) {
              track.stop();
            });
          }

          var a = $(id2)[0];
          if (a != null && a != undefined) {
            const stream = a.srcObject;
            stream.getTracks().forEach(function(track) {
              track.stop();
            });
          }
        }

        var id = "#video-" + this.$store.state.me.id;
        var id2 = "#audio-" + this.$store.state.me.id;

        var a = $(id)[0];
        if (a != null && a != undefined) {
          const stream = a.srcObject;
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
        }

        var a = $(id2)[0];
        if (a != null && a != undefined) {
          const stream = a.srcObject;
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
        }
      } catch (e) {}
    },
    toggleParticipantsVideo() {
      this.me.audioOnly
        ? this.roomClient.disableAudioOnly()
        : this.roomClient.enableAudioOnly();
    },

    toggleMute() {
      this.me.audioMuted
        ? this.roomClient.unmuteAudio()
        : this.roomClient.muteAudio();
    },
    onInvitationLinkClick(event) {
      // If this is a 'Open in new window/tab' don't prevent
      // click default action.
      if (
        event.ctrlKey ||
        event.shiftKey ||
        event.metaKey ||
        // Middle click (IE > 9 and everyone else).
        (event.button && event.button === 1)
      ) {
        return;
      }

      event.preventDefault();
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/media/Room.vue